import { render, staticRenderFns } from "./StickerMessageEditor.vue?vue&type=template&id=95daaa04&"
import script from "./StickerMessageEditor.vue?vue&type=script&lang=js&"
export * from "./StickerMessageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports